export type FindMySchoolSidebarMode = "schools" | "community";

export interface FindMySchoolModeTab {
  key: FindMySchoolSidebarMode;
  label: string;
}

export const FIND_MY_SCHOOL_MODE_TABS: readonly FindMySchoolModeTab[] = [
  { key: "schools", label: "Schools" },
  { key: "community", label: "Community & Services" },
];
